import React from 'react';
import {Prompt, withRouter} from 'react-router-dom';

import http from 'api/http';
import { componentAPI, oilAPI } from 'api/requests';

import Header from './Header';
import FormulaTypeSection from './FormulaTypeSection';
import NotesSection from './Notes';
import GeneralInformation from './GeneralInformation';
import FilePicker from 'Components/FilePicker';
import NotificationManager from 'dom-managers/notification';
import ApplicationActions from 'Components/ApplicationActions';
import ContactDetails from './ContactDetails'
import Modal from 'Components/Modal';
import Button, {buttonColor, buttonType} from 'Components/Button';

@withRouter
export default class DetailsApplication extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      inputErrors: {},
      isModalOpen: false,
    };

    this.filesIdsToDelete = [];

    this.requiredFields = ['formulatorNumber', 'manufacturerAddress', 'testReports'];

    const applicationData = props.applicationData;

    if (applicationData) {
      this.state = { ...this.state, ...applicationData };
    }

    this.someDataWasInputted = false;
  }

  componentDidUpdate() {
    const { applicationData } = this.props;

    if (applicationData && !this.state.formulatorNumber) {
      this.setState(prevState => {
        return { ...prevState, ...applicationData };
      });
    }
  }

  handleInputChange = field => (value, error) => {
    const { inputErrors } = this.state;

    this.someDataWasInputted = true;

    if (!error || error.ops) {
      delete inputErrors[field];
      this.setState({ [field]: value, inputErrors });
    }
  };

  handleSelect = fieldName => input => {
    const { inputErrors } = this.state;
    let newInputErrors = inputErrors;
    const selectedItem = input.value || input;

    delete newInputErrors[fieldName];
    this.someDataWasInputted = true;
    this.setState({ [fieldName]: selectedItem, inputErrors: newInputErrors });
  };

  handleFileSelect = files => {
    let newInputErrors = this.state.inputErrors;
    delete newInputErrors.testReports;
    this.someDataWasInputted = true;
    this.setState(prevState => ({
      testReports: [...prevState.testReports, ...files],
      inputErrors: newInputErrors,
    }));
  };

  handleRemoveFile = index => () => {
    const { testReports } = this.state;

    if (testReports[index].created) {
      this.filesIdsToDelete.push(testReports[index].id);
    }

    let newInputErrors = this.state.inputErrors;
    if (testReports.length === 1) newInputErrors.testReports = true;
    this.someDataWasInputted = true;
    this.setState(prevState => {
      prevState.testReports.splice(index, 1);
      return { testReports: prevState.testReports, inputErrors: newInputErrors };
    });
  };

  handleBackButtonClick = () => {
    const { user } = this.props;
    user.goToList();
  };

  _openModal = () => {
    this.setState({ isModalOpen: true });
  };

  _closeModal = () => {
    this.setState({ isModalOpen: false, requestInProcess: false });
  };

  validateForm = () => {
    const { inputErrors } = this.state;
    let newInputErrors = inputErrors;

    const isEmptyArray = object => {
      return object.length !== undefined && typeof object === 'object' && !object.length;
    };

    const isEmptyString = object => {
      return !object.length && typeof object === 'string' && !object.length;
    };

    const isEmptyObject = object => {
      return object.length === undefined && typeof object === 'object' && !Object.keys(object).length;
    };

    this.requiredFields.forEach(fieldName => {
      if (
        isEmptyString(this.state[fieldName]) ||
        isEmptyArray(this.state[fieldName]) ||
        isEmptyObject(this.state[fieldName])
      )
        newInputErrors[fieldName] = true;
    });

    return new Promise((resolve, reject) => {
      this.setState({ inputErrors: newInputErrors }, () => {
        if (Object.keys(this.state.inputErrors).length) reject();
        else resolve();
      });
    });
  };

  submitFormula = () => {
    const { formulatorNumber, manufacturerAddress, description, notes, testReports } = this.state;
    const { user, match, updateSingleListEntry } = this.props;

    this.validateForm().then(() => {
      const headers = {
        'Content-Type': 'multipart/form-data',
      };

      let dataPayload = {
        id: match.params.applicationId,
        formulatorNumber,
        manufacturerAddress,
        description,
        notes,
        fileIdsToDelete: this.filesIdsToDelete,
      };

      const data = new FormData();
      data.append('requestJson', JSON.stringify(dataPayload));
      testReports.forEach(file => {
        if (!file.created) data.append('reports', file);
      });

      http.post(oilAPI.updateFormula, data, { headers }).then(({ data }) => {
        updateSingleListEntry(match.params.applicationId)(data);
        this.someDataWasInputted = false;
        NotificationManager.success(1, 'Formulation details successfully updated');
        user.goToList();
      });
    });
  };

  blockUnconfirmedTransition = location => {
    const { user } = this.props;

    if (this.someDataWasInputted) {
      this.modalBody = 'You have unsaved data. Are you sure you want to exit application without saving?';
      this.modalConfirmAction = () => {
        this.someDataWasInputted = false;
        this._closeModal();
        user.goTo(location);
      };
      this._openModal();
      return false;
    }
    return true;
  };

  render() {
    const { inputErrors, description, formulatorNumber, manufacturerAddress, notes, testReports, isModalOpen } =
      this.state;
    const { user, match, applicationData, manufacturerAddresses } = this.props;

    const { applicationId } = match.params;

    if (!applicationData) {
      return (
        <section className='scene__scene-wrapper'>
          <section className='scene__content-wrapper detailsScene__content-wrapper'>
            <Header user={user} loadInProgress={true} />
            <div className='ect-spinner _width_pc_100 _height_120'>
              <div className='ect-spinner__image' />
            </div>
          </section>
        </section>
      );
    } else {
      const {
        applicationStatus,
        isReadAcrossFormula,
        baseOilNumber,
        isPaid,
        submissionDate,
        baseFormulaBaseOilNumber,
        engineType,
        approvalDate,
        submittedBy,
      } = applicationData;

      return (
        <React.Fragment>
          <section className='scene__scene-wrapper'>
            <section
              className={`scene__content-wrapper detailsScene__content-wrapper ${applicationStatus.toLowerCase()}`}
            >
              <Header
                applicationStatus={applicationStatus}
                applicationId={applicationId}
                handleBackButtonClick={this.handleBackButtonClick}
                loadInProgress={!applicationData}
              />
              <FormulaTypeSection
                isReadAcrossFormula={isReadAcrossFormula}
                baseOilNumber={baseOilNumber}
                isPaid={isPaid}
              />
              <GeneralInformation
                submissionDate={submissionDate}
                approvalDate={approvalDate}
                formulatorNumber={formulatorNumber}
                baseFormulaBaseOilNumber={baseFormulaBaseOilNumber}
                engineType={engineType}
                isReadAcrossFormula={isReadAcrossFormula}
                description={description}
                handleInputChange={this.handleInputChange}
                inputErrors={inputErrors}
              />
              <NotesSection user={user} notes={notes} handleInputChange={this.handleInputChange} />
              <ContactDetails
                user={user}
                submittedBy={submittedBy}
                manufacturerAddress={manufacturerAddress}
                handleSelect={this.handleSelect}
                inputErrors={inputErrors}
                applicationStatus={applicationStatus}
                manufacturerAddresses={manufacturerAddresses}
              />
              <section className='scene_section'>
                <FilePicker
                  isEditable={user.isInternal() || applicationStatus === 'INCOMPLETE'}
                  handleFileSelect={this.handleFileSelect}
                  handleRemoveFile={this.handleRemoveFile}
                  files={testReports}
                  error={inputErrors.testReports ? 'Please upload at least one report' : ''}
                  editableStateSectionHeader='Upload Test Report and Supporting Documentation'
                  sectionHeaderClassName='_margin_top_0 _font_size_14'
                  httpParams={{
                    currentId: applicationId,
                    currentMethod: componentAPI.downloadReport,
                    fileIdFieldName: 'id',
                  }}
                />
              </section>
              <ApplicationActions
                saveButtonLabel='Save'
                saveButtonAction={this.submitFormula}
                cancelButtonLabel='Cancel'
                cancelButtonAction={this.handleBackButtonClick}
              />
            </section>
          </section>
          <Modal isOpen={isModalOpen}>
            <header className='ect-modal-header'>Confirmation</header>
            <div className='ect-modal-body'>{this.modalBody}</div>
            <footer className='ect-modal-footer'>
              <Button
                label='No'
                type={buttonType.secondary}
                color={buttonColor.gray}
                buttonClassName='_height_40 _width_160'
                onClick={this._closeModal}
              />
              <Button label='Yes' buttonClassName='_height_40 _width_160' onClick={this.modalConfirmAction} />
            </footer>
          </Modal>
          <Prompt message={this.blockUnconfirmedTransition} />
        </React.Fragment>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/formula/Application/Edit/index.jsx